import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { HelpersProvider } from '../../providers/helpers/helpers';
import { I18nProvider } from '../../providers/i18n/i18n';
import { ModernDatepickerHeaderComponent } from '../modern-datepicker-header/modern-datepicker-header.component';


@Component({
  selector: 'dialog-select-date',
  templateUrl: 'dialog-select-date.html',
})

export class DialogSelectDateComponent implements OnDestroy {
  constructor(
    private helpers: HelpersProvider,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<DialogSelectDateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public i18n: I18nProvider,
  ) {
    this.STRINGS = this.i18n.translate();
  }

  STRINGS: any;
  PAGE: any;
  readonly datepickerHeader = ModernDatepickerHeaderComponent;

  date_selected = null;
  user: any = [];

  ngOnInit() {
    if (this.data.date_selected !== null) {
      if (this.data.date_selected.length < 11) this.data.date_selected = this.data.date_selected + ' 23:59:59';
    }
    this.date_selected = this.data.date_selected ? new Date(this.data.date_selected) : null;
  }

  setDatepickerOpen(open: boolean): void {
    const themeRoot = document.getElementById('main-body') || document.body;
    themeRoot.classList.toggle('modern-program-expiration-datepicker-open', open);
  }

  ngOnDestroy(): void {
    this.setDatepickerOpen(false);
  }


}
